import { jsx as _jsx } from "react/jsx-runtime";
import { Table as HeroTable } from '@heroui/react';
export const Table = (props) => {
    return _jsx(HeroTable, { ...props });
};
export default Table;
//# sourceMappingURL=Table.js.map